import { BASE_URL } from "./constants.js";
import { InvalidTokenException } from "./exceptions.js";
import { interceptResponse, isTokenValid } from "./utils.js";

class Auth{
    #type;
    #token;
    #email;
    #secretKey;
    sipUsername;
    sipToken;
    #isLoggedIn = false;

    constructor({type, token, email}){
        this.#email=email;
        this.#token=token;
        this.#type=type;
        this.sipUsername = null;
        this.sipToken = null;
        this.#secretKey = null;
    }
    
   async registerSoftphone(){
        if(this.#type === 'JWT'){
            const tokenValidity = isTokenValid(this.#token);
            if(tokenValidity && typeof tokenValidity !== 'boolean'){
              throw new InvalidTokenException('Softphone.login', tokenValidity);
        }
        }
        const res = await fetch(BASE_URL + '/calls/register-softphone/', {
            method : 'GET',
            headers : {
                'Authorization' : this.#type === 'JWT' ? `Bearer ${this.#token}` : `Secret-Key ${this.#secretKey}`
            }
        });
        const iResponse = interceptResponse(res, 'login');
        const response = await iResponse?.json();
        this.sipUsername = response.username;
        this.sipToken = response.access_token;
        return true;
    }

    async obtainSecretKey() {
        if(this.#type === 'JWT'){
            console.warn('Secret key is required only for auth type OAuth2.0');
            return;
        }
        const tokenValidity = isTokenValid(this.#token);
        if(tokenValidity && typeof tokenValidity !== 'boolean'){
            throw new InvalidTokenException('Softphone.login', tokenValidity);
        }
        const res = await fetch(BASE_URL + `/integrations/obtain-secret-key/?email=${encodeURIComponent(this.#email)}&source=sdk`, {
            method: 'GET',
            headers : {
                'Authorization' : `Bearer ${this.#token}`
            }
        });
        const iResponse = interceptResponse(res, 'login');
        const response = await iResponse?.json();
        this.#secretKey = response?.['secret-key']
    }

    get getSipToken() {
        return this.sipToken
    }

    get getToken() {
        return this.#token
    }

    get getSecretKey(){
        return this.#secretKey
    }

    /**@param {Boolean} newLoginState  */
    set isLoggedIn(newLoginState) {
        this.#isLoggedIn = newLoginState;
    }

    get getIsLoggedIn() {
        return this.#isLoggedIn
    }
}

export default Auth;